import City from './city';
import Entity from './entity';

export default class Customer extends Entity<number> {
  city: City;
  name: string;
  surname: string;
  gsm: string;
  fullName: string;
  languageId: string;
  hotelId: any;
  regionId: any;
  agencyId: any;
  tcNumber: any;
  email: string;
  title: string;
  phone: string;
  cityId: number;
  districtId: number;
  address: string;
  taxOffice: string;
  taxNumber: string;
  orderId:string;
}
